var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('CustomChart',{ref:"chart",attrs:{"data":_vm.functionData},on:{"column-update":_vm.getInvoices}},[_c('template',{slot:"actions"},[(_vm.metaData)?_c('div',{staticClass:"balance-display"},[_c('h3',[_vm._v("PDV: "+_vm._s(_vm.priceDisplay(_vm.metaData.vat)))]),_c('h3',[_vm._v("Bez PDV-a: "+_vm._s(_vm.priceDisplay(_vm.metaData.withoutVat)))]),_c('h3',[_vm._v(" Zaduženo fakturama: "+_vm._s(_vm.priceDisplay(_vm.metaData.totalAmount))+" ")])]):_vm._e()])],2)],1),(_vm.showInvoice)?_c('Invoice',{ref:"invoice",attrs:{"id":_vm.$route.query.id},on:{"saved-invoice":_vm.getInvoices,"close-invoice":_vm.closeInvoice}}):(_vm.payment !== null)?_c('Payment',{attrs:{"cash":_vm.$route.query.filter === 'cash',"client":_vm.payment.client,"payment":_vm.payment,"mode":'inPayment'},on:{"saved":_vm.getInvoices,"close":function($event){_vm.payment = null}}}):_vm._e()],1),_c('SearchTable',{key:_vm.reloading,ref:"table",attrs:{"header":_vm.$route.query.filter === 'cash'
        ? {
            title: 'Blagajna izlaz',
            icon: 'savings',
            class: 'md-card-header-brand',
          }
        : {
            title: 'Izlazne fakture',
            icon: 'arrow_forward',
            class: 'md-card-header-brand',
          },"queriedData":_vm.invoices,"metaData":_vm.metaData,"getItems":_vm.getInvoices,"params":_vm.params,"sortBy":'invoiceNumber',"newItem":_vm.newPayment,"openItem":_vm.openInvoice,"templates":_vm.templates,"individualFunction":!_vm.$route.query.filter
        ? [
            {
              function: _vm.openAdditionalDocument,
              class: 'md-round',
              icon: 'description',
              condition: _vm.hasAdditionalDocument,
            },
            {
              function: _vm.sendForVat,
              class: '',
              icon: 'qr_code',
              condition: _vm.isNotSentForVat,
            },
            {
              function: _vm.cancelInvoice,
              class: 'md-danger',
              icon: 'qr_code_scanner',
              condition: _vm.isSentForVat,
            },
            {
              function: _vm.downloadInvoice,
              class: 'md-round md-success',
              icon: 'download',
            } ]
        : [
            {
              function: _vm.openAdditionalDocument,
              class: 'md-round',
              icon: 'description',
              condition: _vm.hasAdditionalDocument,
            },
            {
              function: _vm.downloadInvoice,
              class: 'md-round md-success',
              icon: 'download',
            } ],"forEachSelected":[
      {
        icon: 'sync',
        label: 'Konvertuj',
        class: 'md-warning',
        function: _vm.convert,
      },
      {
        icon: 'delete',
        label: 'Briši',
        class: 'md-danger',
        function: _vm.deleteInvoices,
      } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }